export class RecyclingFolderBuybackDetail {
  constructor(
    technicalId,
    recyclingBoomerangId,
    recyclingName,
    recyclingBuybackPriceId,
    buybackPrice,
    buybackClientPart,
    buybackStorePart,
    conditionTitle,
    conditionDetail,
    isRecycler,
    createdAt
  ) {
    this.technicalId = technicalId
    this.recyclingBoomerangId = recyclingBoomerangId
    this.recyclingName = recyclingName
    this.recyclingBuybackPriceId = recyclingBuybackPriceId
    this.buybackPrice = buybackPrice
    this.buybackClientPart = buybackClientPart
    this.buybackStorePart = buybackStorePart
    this.conditionTitle = conditionTitle
    this.conditionDetail = conditionDetail
    this.isRecycler = isRecycler
    this.createdAt = createdAt
  }
}
